<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>LỰA CHỌN NHÓM ĐỀ XUẤT</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="search-box">
            <mat-form-field class="full" appearance="legacy">
                <mat-label>Nhập và Enter để tìm kiếm</mat-label>
                <input matInput placeholder="Nhập tên nhóm đề xuất" (change)="onSearch($event)">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        <div class="result">
            <div class="row item" *ngFor="let group of displayingGroups" (click)="onSelect(group)">
                {{group.name}}
            </div>
        </div>
    </mat-dialog-content>
</div>